import { isBoolean, isNil } from 'lodash-es'
import { getDataClass } from 'scrivito'

import { DataClassName } from '@/Data/const'
import { ReferenceFilter } from '@/Data/typesV2'

export const getReferenceDataClass = (
  referenceTo: string,
  referenceFilter?: ReferenceFilter,
) => {
  const isContact =
    referenceTo === 'Contact' && isNil(referenceFilter?.isPerson)

  const isPerson = referenceTo === 'Contact' && referenceFilter?.isPerson

  const isCompany =
    referenceTo === 'Contact' &&
    isBoolean(referenceFilter?.isPerson) &&
    !referenceFilter.isPerson

  if (isContact) {
    return getDataClass(DataClassName.CONTACT)
  }

  if (isPerson) {
    return getDataClass(DataClassName.PERSON)
  }

  if (isCompany) {
    return getDataClass(DataClassName.COMPANY)
  }

  return getDataClass(referenceTo)
}
